import React from 'react';
import Img from 'img';
import s from './ads-aside.module.scss';

export default function ({ image, href, ...props }) {
  return (
    <a className={s.root} href={href} target="_blank" rel="noopener noreferrer">
      <div className={s.image}>
        <Img effect className={s.img} src={image} alt={image} />
      </div>
    </a>
  );
}
